<button
  (click)="voltarAoTopo()"
  aria-label="Voltar ao topo">
  <img src="/assets/icons/arrow.svg" alt="Ícone de seta para cima">
  Topo
</button>
